import { ReactComponent as CheckIcon } from "../../../assets/icons/check.svg";
import { ReactComponent as WarningIcon } from "../../../assets/icons/warning.svg";
import { ReactComponent as InfoIcon } from "../../../assets/icons/information.svg";
import { ReactComponent as CloseIcon } from "../../../assets/icons/closeCircleFilled.svg";
import "../../../css/Banners/Banner.css";

const Banner = ({ type = "", message }) => {
  // console.log("Banner type:", type);
  const getIcon = () => {
    switch (type) {
      case "success":
        return <CheckIcon />;
      case "warning":
        return <WarningIcon />;
      case "info":
        return <InfoIcon />;
      case "error" :
        return <CloseIcon />;
      default:
        return null;
    }
  };

  return (
    <div className={`AML-Banner ${type}`}>
      {getIcon()}
      <div className="AML-Text-Body">{message}</div>
    </div>
  );
};

export default Banner;
